module.exports = __webpack_public_path__ + "img/step19_a-b_failed_stacker-support.7a2bf46d.png";